import React, { useMemo, useState } from 'react';
import { Box, Skeleton } from '@mui/material';
import { Text } from 'src/components/BeaconV2Components/Generic/Text';
import colors from 'src/utils/colors';
import { usePresentationFormContext } from 'src/components/BeaconV2Components/ExperimentalLayout/Settings/Presentations/PresentationFormContext';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import IconButton from 'src/components/BeaconV2Components/Generic/IconButton';
import { TooltipIcon } from 'src/components/SvgIcons/SvgIcons';
import InfoModal from 'src/components/BeaconV2Components/ExperimentalLayout/Settings/Presentations/components/InfoModal';

const BuilderHeader = () => {
  const { quota, isQuotaLoading } = usePresentationFormContext();
  const [isOpen, setIsOpen] = useState(false);
  const presentationsRemaining = useMemo(() => {
    if (!quota) return 0;
    return quota.limit - quota.usage;
  }, [quota]);

  return (
    <Box display="flex" justifyContent="space-between" alignItems="center">
      <Text variant="h2">Presentation Builder</Text>
      {isQuotaLoading ? (
        <Skeleton
          variant="text"
          width={157}
          height={60}
          sx={{
            transform: 'none',
            backgroundColor: colors.graysPrimary
          }}
        />
      ) : (
        <Flex flexDirection="column" sx={{
          backgroundColor: colors.graysPrimary,
          border: `1px solid ${colors.graysSecondary}`,
          borderRadius: '8px',
          padding: '8px 12px'
        }}>
          <Flex alignItems="center" gap={8}>
              <Text sx={{
                color: colors.grey,
                lineHeight: '20px', textTransform: 'uppercase', fontSize: '12px', fontWeight: '500'
              }}>
              Credit balance
            </Text>
            <IconButton
              onClick={() => setIsOpen(true)}
              sxProps={{ padding: '0', '&:hover': { backgroundColor: 'transparent' } }}
            >
              <TooltipIcon width={16} height={16} />
            </IconButton>
          </Flex>
          <Text variant="h5" fontWeight={500}>
            {presentationsRemaining}
          </Text>
          <InfoModal isOpen={isOpen} setIsOpen={setIsOpen} mode="Presentations" />
        </Flex>
      )}
    </Box>
  );
};

export default BuilderHeader;
